import { h, render } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { removeFromWishlist } from '../../wishlist/index';
import { WishlistModal } from './WishlistModal';
import { createList, deleteList, editList, refreshLists } from '../../wishlist/index';
import { openModal } from '../../theme/modal';
import { WishlistCover } from './WishlistCover';
import { ShowWishlist } from './ShowWishlist';
import { WishlistShare } from './WishlistShare';
import { t } from '../../theme/locales';
const WishlistPage = ({ bannerImage  })=>{
    var _pageState_currentList, _pageState_currentList1, _pageState_currentList2, _pageState_currentList3, _pageState_currentList4, _pageState_currentList5, _pageState_currentList6;
    const [removing, setRemoving] = useState(false);
    const [wishLists, setWishLists] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [modalMode, setModalMode] = useState('create');
    const [editingList, setEditingList] = useState();
    const [loading, setLoading] = useState(true);
    const [pageState, setPageState] = useState({
        level: 0,
        currentList: undefined
    });
    useEffect(()=>{
        const fetchData = async ()=>{
            try {
                if (!window._swat) {
                    console.error('Swym API not initialized');
                    return;
                }
                const swat = window._swat;
                const lists = await refreshLists(swat);
                setWishLists(lists);
                const currentList = lists.filter((list)=>{
                    var _pageState_currentList;
                    return list.lid === ((_pageState_currentList = pageState.currentList) === null || _pageState_currentList === void 0 ? void 0 : _pageState_currentList.lid);
                })[0];
                setPageState((prevState)=>({
                        ...prevState,
                        currentList
                    }));
            } catch (error) {
                console.error('Error fetching wishlists:', error);
            } finally{
                setLoading(false);
            }
        };
        window.addEventListener('swym:ready', fetchData);
        return ()=>{
            window.removeEventListener('swym:ready', fetchData);
        };
    }, [
        (_pageState_currentList = pageState.currentList) === null || _pageState_currentList === void 0 ? void 0 : _pageState_currentList.lid
    ]);
    const handleRemoveFromWishlist = async (lid, item)=>{
        if (!window._swat) return;
        const swat = window._swat;
        try {
            setRemoving(true);
            const deletedItem = await removeFromWishlist(lid, swat, {
                epi: item.epi,
                empi: item.empi,
                du: item.du
            });
            if (!deletedItem) {
                throw new Error('Failed to remove item from wishlist');
            }
            const lists = await refreshLists(swat);
            setWishLists(lists);
            setPageState((prevState)=>{
                return {
                    ...prevState,
                    currentList: prevState.currentList ? lists.find((list)=>{
                        var _prevState_currentList;
                        return list.lid === ((_prevState_currentList = prevState.currentList) === null || _prevState_currentList === void 0 ? void 0 : _prevState_currentList.lid);
                    }) : undefined
                };
            });
        } catch (error) {
            console.error('Failed to remove item from wishlist:', error);
        } finally{
            setRemoving(false);
        }
    };
    const handleViewList = (list)=>{
        window.scrollTo({
            top: 0
        });
        setPageState({
            level: 1,
            currentList: list
        });
    };
    const openCreateModal = ()=>{
        setModalMode('create');
        setEditingList(undefined);
        setModalOpen(true);
    };
    const openEditModal = (list)=>{
        setModalMode('edit');
        setEditingList(list);
        setModalOpen(true);
    };
    const handleModalSubmit = async (e, name, submitMode)=>{
        e.preventDefault();
        if (!window._swat) return;
        const swat = window._swat;
        const nextName = name.trim();
        setModalLoading(true);
        try {
            if (submitMode === 'create') {
                if (!nextName) {
                    setModalLoading(false);
                    return;
                }
                await createList(swat, nextName);
            } else if (submitMode === 'edit') {
                if (!editingList || !nextName) {
                    setModalLoading(false);
                    return;
                }
                await editList(editingList.lid, nextName, swat);
            } else {
                if (editingList) {
                    const deleteListRequest = await deleteList(editingList.lid, swat);
                    if (deleteListRequest) {
                        const lists = await refreshLists(swat);
                        setWishLists(lists);
                    }
                }
            }
        } catch (error) {
            console.error('Error processing wishlist modal submit:', error);
        } finally{
            const lists = await refreshLists(swat);
            setModalLoading(false);
            setModalOpen(false);
            setPageState((prevState)=>{
                return {
                    ...prevState,
                    level: submitMode === 'delete' ? 0 : prevState.level,
                    currentList: prevState.currentList ? lists.find((list)=>{
                        var _prevState_currentList;
                        return list.lid === ((_prevState_currentList = prevState.currentList) === null || _prevState_currentList === void 0 ? void 0 : _prevState_currentList.lid);
                    }) : undefined
                };
            });
            setWishLists(lists);
        }
    };
    if (loading) {
        return h('div', {
            className: 'wishlist-page'
        }, [
            h('div', {
                role: 'status',
                'aria-live': 'polite'
            }, t('wishlist.loading'))
        ]);
    }
    return h('div', null, [
        pageState.level === 1 && pageState.currentList && h('div', {
            className: 'wishlist-banner'
        }, [
            h('div', {
                className: 'wishlist-banner__content'
            }, [
                h('div', {
                    className: 'wishlist-banner__layer'
                }, []),
                h('div', {
                    className: 'wishlist-banner__image'
                }, [
                    h('img', {
                        src: bannerImage || 'https://cdn.swymrelay.com/swym/wishlist-banner.png',
                        alt: t('wishlist.banner_alt')
                    })
                ]),
                h('h1', {
                    className: 'wishlist-banner__title'
                }, (_pageState_currentList1 = pageState.currentList) === null || _pageState_currentList1 === void 0 ? void 0 : _pageState_currentList1.lname)
            ])
        ]),
        h('div', {
            className: 'wishlist-page'
        }, [
            h('div', {
                className: 'wishlist-page__header'
            }, [
                h('div', {
                    className: 'wishlist-page__breadcrumbs'
                }, [
                    h('a', {
                        href: '/account',
                        className: 'wishlist-page__breadcrumb-link'
                    }, t('wishlist.my_account')),
                    h('span', {
                        className: 'wishlist-page__breadcrumb-separator'
                    }, ' > '),
                    h('span', {
                        'data-testid': 'wishlist-breadcrumb-current',
                        className: !pageState.currentList ? 'wishlist-page__breadcrumb-current' : 'wishlist-page__breadcrumb-link',
                        onClick: ()=>{
                            window.scrollTo({
                                top: 0
                            });
                            setPageState({
                                level: 0,
                                currentList: undefined
                            });
                        }
                    }, t('wishlist.my_wishlists')),
                    pageState.currentList && pageState.level === 1 && h('span', {
                        className: 'wishlist-page__breadcrumb-separator'
                    }, ' > '),
                    h('span', {
                        className: 'wishlist-page__breadcrumb-current'
                    }, ((_pageState_currentList2 = pageState.currentList) === null || _pageState_currentList2 === void 0 ? void 0 : _pageState_currentList2.lname) || '')
                ]),
                pageState.level === 0 ? h('button', {
                    type: 'button',
                    className: 'wishlist-page__create-btn',
                    'data-testid': 'wishlist-create-list-button',
                    onClick: openCreateModal
                }, t('wishlist.create_new_list')) : h('div', {
                    className: 'wishlist-page__actions'
                }, [
                    window.swymSelectedListName !== ((_pageState_currentList3 = pageState.currentList) === null || _pageState_currentList3 === void 0 ? void 0 : _pageState_currentList3.lname) && window.swymSelectedListId !== ((_pageState_currentList4 = pageState.currentList) === null || _pageState_currentList4 === void 0 ? void 0 : _pageState_currentList4.lid) && h('button', {
                        className: 'wishlist-page__action-btn--edit',
                        onClick: ()=>pageState.currentList && openEditModal(pageState.currentList)
                    }, t('wishlist.edit')),
                    ((_pageState_currentList5 = pageState.currentList) === null || _pageState_currentList5 === void 0 ? void 0 : _pageState_currentList5.listcontents) && ((_pageState_currentList6 = pageState.currentList) === null || _pageState_currentList6 === void 0 ? void 0 : _pageState_currentList6.listcontents.length) > 0 && h('button', {
                        type: 'button',
                        className: 'wishlist-page__create-btn',
                        onClick: ()=>{
                            var _pageState_currentList, _pageState_currentList1, _pageState_currentList2;
                            return openModal(pageState.currentList && h(WishlistShare, {
                                lid: (_pageState_currentList = pageState.currentList) === null || _pageState_currentList === void 0 ? void 0 : _pageState_currentList.lid,
                                lname: (_pageState_currentList1 = pageState.currentList) === null || _pageState_currentList1 === void 0 ? void 0 : _pageState_currentList1.lname
                            }), {
                                ariaLabel: t('wishlist.share_wishlist_aria'),
                                id: `share-modal-${(_pageState_currentList2 = pageState.currentList) === null || _pageState_currentList2 === void 0 ? void 0 : _pageState_currentList2.lid}`,
                                category: 'wishlist-share'
                            });
                        }
                    }, t('wishlist.share_wishlist'))
                ])
            ]),
            pageState.level === 0 && h('div', {
                className: 'wishlist-page__content'
            }, [
                h('div', {
                    className: 'wishlist-page__grid unique'
                }, wishLists && wishLists.length > 0 && wishLists.map((list)=>h(WishlistCover, {
                        wishlist: list,
                        handleViewList: handleViewList
                    })))
            ]),
            pageState.level === 1 && pageState.currentList ? h(ShowWishlist, {
                key: `${pageState.currentList.lid}-${pageState.currentList.listcontents.length}-${pageState.currentList.listcontents.map((item)=>`${item.epi}-${item.empi || ''}`).join('|')}`,
                wishlist: pageState.currentList,
                handleRemoveFromWishlist: handleRemoveFromWishlist,
                removing: removing
            }) : null,
            h(WishlistModal, {
                isOpen: modalOpen,
                mode: modalMode,
                title: modalMode === 'create' ? t('wishlist.create_new_list_title') : t('wishlist.edit_list_title'),
                initialValue: modalMode === 'edit' ? editingList === null || editingList === void 0 ? void 0 : editingList.lname : '',
                onClose: ()=>setModalOpen(false),
                onSubmit: handleModalSubmit,
                list: editingList,
                isLoading: modalLoading
            })
        ])
    ]);
};
export const init = async function() {
    const container = document.querySelector('.js-wishlist-page');
    if (!container) {
        return;
    }
    render(h(WishlistPage, {
        bannerImage: container.getAttribute('data-image-banner')
    }), container);
};
